export default "__VITE_ASSET__9caf4ede__"